import { useEffect, useState } from 'react'

/**
 * useToggleHotDropdown
 *
 * This is a workaround to allow keyboard navigation.
 * We expect this should be fixed in Cosmos lib.
 */
export const useToggleHotDropdown = (hotDropdownRef: JSX.IntrinsicElements['hot-dropdown']) => {
  const [menuState, setMenuState] = useState(false)

  function toggle() {
    const hotDropdown = hotDropdownRef.current || null

    if (hotDropdown) {
      menuState ? hotDropdown?.closeMenu() : hotDropdown?.openMenu()
    }
  }

  // This function intends to prevent dropdowns overlapping each other
  function closeAllOtherDropdowns() {
    const otherDropdowns = [...document.querySelectorAll('hot-dropdown')].filter(el => el !== hotDropdownRef.current)

    otherDropdowns.forEach((element: JSX.IntrinsicElements['hot-dropdown']) => element?.closeMenu())
  }

  useEffect(() => {
    const closeCallback = () => setMenuState(false)
    const openCallback = () => {
      closeAllOtherDropdowns()
      setMenuState(true)
    }
    const hotDropdown = hotDropdownRef.current || null

    if (hotDropdown) {
      hotDropdown.addEventListener('open', openCallback)
      hotDropdown.addEventListener('close', closeCallback)
    }

    return () => {
      if (hotDropdown) {
        hotDropdown.removeEventListener('open', openCallback)
        hotDropdown.removeEventListener('close', closeCallback)
      }
    }
  })

  return {
    state: menuState,
    toggle
  }
}
